<p-table #tt [value]="users" [loading]="loading" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100,500]"
    (onLazyLoad)="onLoadUsersLazy($event)" [rows]="rowsOnPage" [lazy]="true" [(first)]="first"
    [totalRecords]="totalRecords" styleClass="ui-table">
    <ng-template pTemplate="caption">
        <span style="border-bottom: 3px solid #40499b; padding-bottom: 5px;">{{ 'users_list' | translate }}</span>
        <div class="caption-dropdown" style="position: absolute; top: 10px; right: 10px;">
            <button type="button" pButton icon="pi pi-sliders-h" (click)="onToggleFilters()"
                style="min-width: 60px; margin-right: 10px;"></button>
            <p-dropdown [options]="userRoles" [(ngModel)]="searchParams.role" (onChange)="onSearchUsers()"></p-dropdown>
        </div>
        <div [hidden]="!showFilters" style="margin-left: -10px; margin-right: -10px;">
            <div class="p-grid ui-fluid" style="padding: 15px 0 0 0; margin: 0; background: #fff">
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <input id="id-input" pInputText [(ngModel)]="searchParams.id" type="number" style="width: 100%;">
                        <label for="id-input">ID</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <p-calendar id="calendar-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                            [(ngModel)]="searchParams.dateRange" selectionMode="range" dateFormat="yy-mm-dd"
                            showTime="true" hourFormat="24"></p-calendar>
                        <label for="calendar-input">{{ 'register_date' | translate }}</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <input id="name-input" pInputText [(ngModel)]="searchParams.name" type="text"
                            style="width: 100%;">
                        <label for="name-input">{{ 'name' | translate }}</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <input id="surname-input" pInputText [(ngModel)]="searchParams.surname" type="text"
                            style="width: 100%;">
                        <label for="surname-input">{{ 'surname' | translate }}</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <input id="login-input" pInputText [(ngModel)]="searchParams.login" type="text"
                            style="width: 100%;">
                        <label for="login-input">{{ 'login_name' | translate }}</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                    <span class="ui-float-label">
                        <input id="email-input" pInputText [(ngModel)]="searchParams.email" type="text"
                            style="width: 100%;">
                        <label for="email-input">{{ 'email_address' | translate }}</label>
                    </span>
                </div>
                <div class="p-col-12 p-sm-12 p-md-12 p-lg-12" style="text-align: right;">
                    <button type="button" pButton icon="pi pi-search" (click)="onSearchUsers()"
                        style="min-width: 60px;"></button>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="table-header">
            <th>ID</th>
            <th>{{ 'register_date' | translate }}</th>
            <th>{{ 'name' | translate }}</th>
            <th>{{ 'surname' | translate }}</th>
            <th>{{ 'login_name' | translate }}</th>
            <th>{{ 'email_address' | translate }}</th>
            <th>Kwota z doładowań</th>
            <th>
                <button type="button" pButton icon="pi pi-refresh" (click)="onRefreshSearch()"></button>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="7" style="text-align: center;">
                {{ 'no_data' | translate }}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
        <tr>
            <td>{{user.id}}</td>
            <td>{{user.created_at}}</td>
            <td>{{user.user_details.name}}</td>
            <td>{{user.user_details.surname}}</td>
            <td>{{user.login}}</td>
            <td>{{user.email}}</td>
            <td>{{user.user_details.prepaid_amount | currencyReduce: true | currency: 'PLN' }}</td>
            <td>
                <p-menu #menu [popup]="true" [model]="functionsMenu" appendTo="body"></p-menu>
                <button type="button" pButton icon="pi pi-cog"
                    (click)="onPopulateFunctionsMenu($event, user.id)"></button>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog #confirmDialog header="{{ 'confirmation' | translate }}">
    <p-footer>
        <div *ngIf="showBlockSellingNotesBtn" style="float: left;">
            <p-checkbox name="blockSellingNotes" [(ngModel)]="blockSellingNotes" [binary]="true"
                label="{{ 'confirm_block_selling_notes' | translate }}"></p-checkbox>
        </div>
        <button style="min-width: 60px;" type="button" class="ui-button-success" pButton icon="pi pi-check"
            (click)="confirmDialog.accept()"></button>
        <button style="min-width: 60px;" type="button" class="ui-button-warning" pButton icon="pi pi-times"
            (click)="confirmDialog.reject()"></button>
    </p-footer>
</p-confirmDialog>